

































import Vue from 'vue'
import StatusIcon from '@/components/map/StatusIcon.vue'
import SummaryReport from '@/components/resident-summary/SummaryReport.vue'
import { isInAnyRoom } from '@/utils/patients'

export default Vue.extend({
  components: { StatusIcon, SummaryReport },
  props: {
    sharedRoom: {
      type: Object,
      required: true,
    },
    allPatients: {
      type: Array,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      patientSummaryVisible: false,
      patientSummaryShowBelow: true,
      patientSummaryOffsetTop: 0,
      selectedResident: null,
    }
  },
  computed: {
    cssVars() {
      return {
        '--summary-popup-offset-top': this.patientSummaryOffsetTop + 'px',
      }
    },
    residents() {
      if (!this.sharedRoom || !this.sharedRoom.sharedRoomId) {
        return []
      }
      return this.allPatients.filter(patient => {
        let resident = patient
        return (
          resident &&
          resident.lastConnectionSharedRoomId &&
          resident.lastConnectionSharedRoomId == this.sharedRoom.sharedRoomId &&
          isInAnyRoom(resident)
        ) // ensures we haven't pased the out of room time
      })
      // return this.sharedRoom.currentResidents || []
    },
  },
  methods: {
    getMapRect() {
      return document.getElementById('patient-map').getBoundingClientRect()
    },
    offsetTopInMap() {
      let thisTop = this.$el.getBoundingClientRect().top
      let patientMapTop = this.getMapRect().top
      return (thisTop - patientMapTop) * 1.25 // because LBMF is scale 0.8
    },
    openResidentSummary(resident) {
      // calculated here so we know it's already rendered
      // this.patientSummaryShowBelow = this.isInTopHalfOfMap()
      this.patientSummaryOffsetTop = -this.offsetTopInMap() + 10
      this.selectedResident = resident
      this.patientSummaryVisible = true
    },
    closeReport() {
      setTimeout(() => (this.patientSummaryVisible = false), 0)
    },
  },
})
